import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import PartnerAccountForm from '../../PartnerAccountForm'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'

import { createSelfAccount, clearCreateSelfAccount } from '../../../../../../modules/actions/selfAccounts'
import {
  wasSelfAccountCreatedSelector,
  createSelfAccountIsLoadingSelector,
  createSelfAccountErrorSelector
} from '../../../../../../modules/selectors/selfAccounts'
import { selectedPartnershipSelector } from '../../../../../../modules/selectors/partnerships'

import { PARTNER_ACCOUNT_CREATE } from '../../../../../../constants/forms'
import { getInitialValues, validationSchema } from '../../PartnerAccountForm/fields'

const CreatePartnerAccountForm = () => {
  const dispatch = useDispatch()

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const wasSelfAccountCreated = useSelector(wasSelfAccountCreatedSelector)

  const { rights_holder: rightsHolderId } = selectedPartnership

  const onSubmit = useCallback(
    values => {
      dispatch(
        createSelfAccount({
          ...values,
          account_type: 'partner',
          parent_right_holder: rightsHolderId
        })
      )
    },
    [dispatch, rightsHolderId]
  )

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearCreatePartnerAccountHandler = useCallback(() => {
    dispatch(clearCreateSelfAccount())
  }, [dispatch])

  return (
    <PartnerAccountForm
      formName={PARTNER_ACCOUNT_CREATE}
      formik={purifiedFormik}
      successSubmit={wasSelfAccountCreated}
      errorSelector={createSelfAccountErrorSelector}
      isLoadingSelector={createSelfAccountIsLoadingSelector}
      clearHandler={clearCreatePartnerAccountHandler}
    />
  )
}

export default CreatePartnerAccountForm
